<template>
  <div class="score-board">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <div class="top3-box">
        <div
          v-for="(item, index) of list.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">{{ item.user_nickname }}</div>
          <div class="score">{{ item.jifen }}</div>
        </div>
      </div>
      <div class="score-board-box">
        <div
          class="item"
          v-for="(item, index) of list.slice(3)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right">
            已獲得
            <img src="./images/gold.png" />
            <span class="scroe">{{ item.jifen }}</span>
          </div>
        </div>
      </div>
    </div>
    <div ref="myScoreBox" class="my-score-box" v-drap>
      <img src="./images/my-score.png" alt="" v-if="isPlayer" />
      <span class="my-score" v-if="isPlayer">{{ myScore || 0 }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Scoreboard',
  data() {
    return {
      list: [],
      myScore: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getDetail() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/rank';
        const { data } = await this.$http.get(url);
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/jifen/rank/${uuid}`;
        const { data } = await this.$http.get(url);
        if (data.jifen) {
          this.myScore = data.jifen || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查看陪玩師詳情
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  },
  created() {
    if (new Date().getTime() > new Date('2023/06/21').getTime()) {
      this.$dialog
        .confirm({
          message:
            '當前活動已結束，更多福利敬請留意nicee平台，感謝您的支持呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'dialog-center'
        })
        .then(() => {
          // this.$router.push({ path: '/home' });
        });
    }
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.score-board {
  width: 100%;
  background-color: #9FEEFF;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .top3-box {
      position: absolute;
      top: 923px;
      display: flex;
      right: 87px;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        font-size: 16px;
        flex: none;
        width: 123px;
        color: white;
        &.top1 {
          margin: 0 14px;
          img {
            width: 68px;
            height: 68px;
          }
          .user-name {
            margin-top: 50.86px;
          }
        }
        &.top2 {
          order: -1;
        }
        &.top3 {
          width: 120px;
        }
        img {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          object-fit: cover;
        }
        .user-name,
        .score {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
        }
        .user-name {
          margin-top: 47.84px;
          text-align: center;
        }
        .score {
          margin-top: 8px;
          padding-left: 71px;
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: 1142px;
      right: 96px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 381px;
        font-size: 16px;
        padding: 15px 0;
        margin-bottom: 6px;
        color: #280992;
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .left {
          .index {
            margin-right: 10px;
            width: 17px;
            text-align: right;
          }
          img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            margin-right: 10px;
            object-fit: cover;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 94px;
          }
        }
        .right {
          img {
            width: 18px;
            margin: 0 3px;
          }
        }
      }
    }
  }
  .my-score-box {
    position: fixed;
    right: 60px;
    top: 550px;
    width: 216px;
    img {
      width: 100%;
    }
    .my-score {
      position: absolute;
      right: 14px;
      bottom: 16px;
      font-size: 30px;
      color: white;
      width: 120px;
      text-align: center;
    }
  }
}
</style>
